import axios, { AxiosResponse } from "axios";

export const ApiClient = () => {
  const instance = axios.create({
    baseURL: "",
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.response.use(
    (response) => {
      if (
        typeof response.data === "string" &&
        response.data.includes("<!DOCTYPE html>")
      ) {
        throw new Error("Error");
      }

      return response;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  async function get<R, P>(path: string, params?: P) {
    const response: AxiosResponse<R> = await instance.get(path, {
      params,
      withCredentials: true,
    });
    return response;
  }

  const post = async <T>(path: string, data: T) => {
    const response = await instance.post(path, data);

    return response;
  };

  return {
    get,
    post,
  };
};
